import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Breadcrumbs from "components/Common/Breadcrumb";
import DataTable from "../../components/Common/LocalizedDataTable";
import { GeneralSettingApi } from "apis/GeneralSettingApi";
import { withTranslation } from "react-i18next";
import config from "config/config";
import { Link } from "react-router-dom";
import Swal from "../../helpers/swal_helper";
import { formatNumber } from "../../helpers/language_helper";
function GeneralSettings(props) {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const [activeData, setActiveData] = useState({
        page: 1,
        limit: config.LIMIT,
        totalRows: 0,
    });

    useEffect(() => {
        getAllGeneralSettings(activeData.page, activeData.limit);
    }, []);

    const columns = [
        {
            name: props.t("Sr.No"),
            selector: row => row.sr,
            cell: (row) => formatNumber(row.sr),
            width: "80px",
        },
        {
            name: props.t("Key"),
            selector: row => row.key,
            minWidth: "200px",
        },
        {
            name: props.t("Value"),
            cell: row => (
                <div style={{
                    whiteSpace: "pre-line",
                    wordBreak: "break-word"
                }}>
                    {row.value}
                </div>
            ),
            minWidth: "350px",
        },
        {
            name: props.t("Action"),
            cell: row => row.action,
            width: "100px",
        }
    ];

    const getAllGeneralSettings = async (page, limit) => {

        setLoading(true);

        try {

            const payload = {
                page: page,
                limit: limit
            };

            const res = await GeneralSettingApi.getAllGeneralSettings(payload);

            if (res.data.status) {

                const responseData = res.data.data;
                const pagination = res.data.pagination;

                setActiveData({
                    page: pagination.current_page,
                    limit: pagination.per_page,
                    totalRows: pagination.total,
                });

                const tableData = responseData.map((v, i) => ({
                    sr: (pagination.current_page - 1) * pagination.per_page + i + 1,
                    key: v.key,
                    value: v.value,
                    action: (
                        <Link to={`/edit-general-setting/${v.id}`}>
                            <i className="fas fa-edit" />
                        </Link>
                    )
                }));

                setData(tableData);

            } else {

                Swal.fire("Error", res.data.message, "error");

            }

        } catch (error) {

            Swal.fire("Error", "Failed to fetch General Settings", "error");

        }

        setLoading(false);
    };

    const handlePageChange = (page) => {

        getAllGeneralSettings(page, activeData.limit);

    };

    const handleRowsPerPageChange = (newLimit, page) => {

        getAllGeneralSettings(page, newLimit);

    };

    document.title = props.t("General Setting");

    return (
        <div className="page-content">

            <div className="container-fluid">

                <Breadcrumbs
                    title={props.t("General Setting")}
                    breadcrumbItem={props.t("General Setting")}
                />

                <DataTable
                    columns={columns}
                    data={data}
                    progressPending={loading}

                    pagination
                    paginationServer

                    paginationTotalRows={activeData.totalRows}
                    paginationPerPage={activeData.limit}

                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handleRowsPerPageChange}

                    highlightOnHover
                    responsive
                    noDataComponent={props.t("No records found")}
                />

            </div>

        </div>
    );
}

GeneralSettings.propTypes = {
    t: PropTypes.func,
};

export default withTranslation()(GeneralSettings);
